import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IGroupFolder, ISecuredSharedFoldersStore } from "../types/stores/securedSharedFolders";

const initialState: ISecuredSharedFoldersStore = {
    folders: [],
    isLoading: false,
    togglingFolderId: null,
};

const slice = createSlice({
    name: "securedSharedFolders",
    initialState,
    reducers: {
        securedSharedFoldersIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        updateSecuredSharedFolders: (state, action: PayloadAction<Array<IGroupFolder>>) => {
            state.folders = action.payload;
        },
        updateSecuredSharedFolderStatus: (
            state,
            action: PayloadAction<{ folderId: number; status: IGroupFolder["Status"] }>
        ) => {
            const folder = state.folders.find(f => f.FolderId === action.payload.folderId);
            if (folder) {
                folder.Status = action.payload.status;
            }
        },
        setTogglingFolderId: (state, action: PayloadAction<number | null>) => {
            state.togglingFolderId = action.payload;
        },
    },
});

export default slice.reducer;

export const {
    securedSharedFoldersIsLoading,
    updateSecuredSharedFolders,
    updateSecuredSharedFolderStatus,
    setTogglingFolderId,
} = slice.actions;
